<template>
  <div class="dimension-items">
    <span>维度：</span>
    <el-checkbox v-if="checkAll" class="check-all" v-model="dimensionsCheckAll" :indeterminate="indeterminate" @change="onCheckAllChange">
      全选
    </el-checkbox>
    <el-checkbox-group v-model="checkedItems" @change="onDimensionsChange">
      <el-checkbox v-for="item in props.dimensions" :label="item.key" :key="item.key" :disabled="isDimensionDisabled(item)">
        {{ item.label }}
      </el-checkbox>

      <el-button class="clear-btn" type="text" :disabled="clearDisabled" @click="clearAll">清空</el-button>
    </el-checkbox-group>
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue'

// eslint-disable-next-line
const props = defineProps({
  dimensions: {
    type: Array,
    default: () => []
  },
  value: {
    type: Array,
    required: true
  },
  checkAll: {
    type: Boolean,
    default: false
  },
  minSelected: {
    type: Number,
    default: 0,
    validator: (value) => value >= 0
  }
})
// eslint-disable-next-line
const emits = defineEmits(['input'])

const indeterminate = ref(false)
const dimensionsCheckAll = ref(false)

const clearDisabled = computed(() => props.minSelected > 0 && (props.value || []).length <= props.minSelected)

const checkedItems = computed({
  get() {
    onDimensionsChange(props.value || [])
    return props.value || []
  },
  set(val) {
    emits('input', val)
  }
})

const isDimensionDisabled = (item) => {
  const selectedItems = props.value || []
  return item.disabled || (selectedItems.length <= props.minSelected && selectedItems.includes(item.key))
}

const getMinimumSelectedItems = () => checkedItems.value.slice(0, props.minSelected)

// 全选按钮变化时的处理函数
const onCheckAllChange = (val) => {
  // 获取所有未禁用的选项的key
  const availableItems = props.dimensions.filter((item) => !item.disabled).map((item) => item.key)
  const nextCheckedItems = val ? availableItems : getMinimumSelectedItems()

  // 如果全选按钮被选中，则选中所有未禁用的选项
  checkedItems.value = nextCheckedItems
  onDimensionsChange(nextCheckedItems)
}

// 选项变化时的处理函数
const onDimensionsChange = (value) => {
  // 获取所有未禁用的选项的key
  const availableItems = props.dimensions.filter((item) => !item.disabled).map((item) => item.key)

  // 计算选中的未禁用选项数量
  const checkedCount = value.filter((key) => availableItems.includes(key)).length

  // 设置全选和半选状态
  dimensionsCheckAll.value = checkedCount === availableItems.length && availableItems.length > 0
  indeterminate.value = checkedCount > 0 && checkedCount < availableItems.length
}

// 清空所有选中项
const clearAll = () => {
  if (clearDisabled.value) return

  const nextCheckedItems = props.minSelected > 0 ? getMinimumSelectedItems() : []
  checkedItems.value = nextCheckedItems
  onDimensionsChange(nextCheckedItems)
}

// 监听dimensions变化，更新选中状态
watch(
  () => props.dimensions,
  () => {
    onDimensionsChange(checkedItems.value)
  },
  { deep: true }
)
</script>

<style scoped lang="scss">
.dimension-items {
  display: flex;
  align-items: center;

  ::v-deep .check-all {
    margin-right: 8px;
    .el-checkbox__label {
      font-size: 12px;
    }
  }
  ::v-deep .el-checkbox-group {
    .el-checkbox {
      margin-right: 8px;
      .el-checkbox__label {
        font-size: 12px;
      }
    }
  }
}
</style>
